import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { BulkDonationComponent } from './components/bulkdonation/bulkdonation.component';
import { BulkDonationBtnComponent } from './components/bulkdonation-btn/bulkdonation-btn.component';
import { SharedModule } from '../../shared/shared.module';
import { ProgressBarModule } from '../progress-bar/progress-bar.module';



@NgModule({
  declarations: [
    BulkDonationComponent,
    BulkDonationBtnComponent
  ],
  exports: [
    BulkDonationComponent,
    BulkDonationBtnComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatRippleModule,
    ProgressBarModule
  ]
})
export class BulkDonationModule { 
  getComponent() {
    return BulkDonationBtnComponent;
  }
}
